import React, { Fragment } from 'react';
import { MetricsElement } from "react-metrics";
import PropTypes from 'prop-types';

import BrightCove from '../../shared/components/brightcove';
import YouTube from '../../shared/components/youtube';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import { ModalControl } from '../../context/modal/modal-context';

import '../css/video-content.less';

class VideoPlayer extends React.Component{
    static propTypes = {
        type: PropTypes.oneOf(['YouTube', 'BrightCove']),
        src: PropTypes.string.isRequired
    }

    static defaultProps = {
        type:  'BrightCove',
        playMode: 'inline'
    }

    render(){
        const { type, src, playMode } = this.props;
        let videoComponent = type === 'BrightCove' ? <BrightCove src={src} /> : <YouTube src={src}/>;
        return videoComponent;
    }
}

class VideoContent extends React.Component{
    static propTypes = {
        type: PropTypes.oneOf(['YouTube', 'BrightCove']),
        playMode: PropTypes.oneOf(['inline', 'modal']),
        metricsId: PropTypes.string
    }

    static defaultProps = {
        playMode: 'inline',
        metricsId:'video:play',
        type: 'BrightCove'
    }

    state={
        renderVideo: false
    }

    playVideo = () => {
        this.setState({renderVideo: true});
    };

    render(){
        const { imagePlaceHolderUrl='', bannerText, videoUrl='', sku, playMode, metricsId, type } = this.props;
        let vidPlayer;

        if(playMode === 'modal'){
            vidPlayer = <ModalControl
                  content={VideoPlayer}
                  contentProps={{src: videoUrl, type}}
                  dynamicContent={true}
                  modalProps={{ className:'video-modal'}}
                >
                {
                  (modalProps) => {
                    return (
                    <Fragment>
                        <ImageWithPlaceholder src={imagePlaceHolderUrl}/>
                        <MetricsElement>
                        <div
                        data-metrics-event-name="linkClick"
                        data-metrics-event="e_linkClick"
                        data-metrics-link-id={metricsId}
                        className='play-btn'
                        onClick={modalProps.openModal}
                        ></div>
                        </MetricsElement>
                        {bannerText ? <span className='banner-text'>{bannerText}</span> : null}
                    </Fragment>    

                    );
                  }
                }
                </ModalControl>
        }else{
            vidPlayer = !this.state.renderVideo ?
                                <Fragment>
                                    <ImageWithPlaceholder src={imagePlaceHolderUrl}/>
                                    <MetricsElement>
                                        <div
                                            data-metrics-event-name="linkClick"
                                            data-metrics-event="e_linkClick"
                                            data-metrics-link-id={`pdp:rich-content:video:play:${sku}`}
                                            className='play-btn'
                                            onClick={this.playVideo}
                                        ></div>
                                    </MetricsElement>
                                    {bannerText ? <span className='banner-text'>{bannerText}</span> : null}
                                </Fragment> : <VideoPlayer src={videoUrl}/>;
        }

        return(
            <div className='custom-component video-content'>
            {vidPlayer}
            </div>
        )
    }
}

export default VideoContent